import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "shamsiFull"
})
export class ShamsiFullPipe implements PipeTransform {
  transform(value: Date): string {
    let date=new Date(value);
    let now=new Date();
    return (now.getMonth()-date.getMonth()).toString() + " ماه پیش ";
  }
}
